import { useSelector } from "react-redux";
import { useMemo } from "react";
import Phone from "@assets/images/icons/phone.svg";
import Email from "@assets/images/icons/email.svg";
import Linkedin from "@assets/images/linkedin.svg";
import { SelectionBarTemplete } from "@components/templates/SelectionBar/SelectionBar";

export const SelectionBar = ({ viewPhoneEmail, clearSelection, selectedCompanyArray, type, selectedCompanyValuesArray }) => {
  const userDetails = useSelector((state) => state.userDetails);
  const selectionOptions = useMemo(() => {
    if (userDetails?.userData) {
      let selectionOptionsClone = [
        {
          icon: Phone,
          name: "View Phone",
          cb: () => {
            viewPhoneEmail("phone");
          },
          omit: selectedCompanyValuesArray.every((ele) => ele.hasPhone === false) || selectedCompanyValuesArray.every((ele) => ele?.isPhoneViewed),
        },
        {
          icon: Email,
          name: "View Email",
          cb: () => {
            viewPhoneEmail("email");
          },
          omit: selectedCompanyValuesArray.every((ele) => ele.hasEmail === false) || selectedCompanyValuesArray.every((ele) => ele?.isEmailViewed),
        },
        {
          icon: Linkedin,
          name: "View LinkedIn",
          cb: () => {
            viewPhoneEmail("linkedin");
          },
          omit: selectedCompanyValuesArray.some((ele) => ele.hasEmail),
        },
        {
          name: "View Both",
          cb: () => {
            viewPhoneEmail("both");
          },
          omit: selectedCompanyValuesArray.every((ele) => ele.hasEmail === false || ele.hasPhone === false) || selectedCompanyValuesArray.every((ele) => ele?.isEmailViewed || ele?.isPhoneViewed),
        },
      ];
      return selectionOptionsClone;
    }
  }, [userDetails, selectedCompanyArray]);

  return (
    <div className="d-inline-block mt-3">
      <SelectionBarTemplete type={type} options={selectionOptions} clearSelection={clearSelection} selectedCompanyArray={selectedCompanyArray} />
    </div>
  );
};
